// extracted by mini-css-extract-plugin
export default {"all-games":"YourGames_all-games__V2uii","reward":"YourGames_reward__s4z5I"};